import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';

/*
Generated class for the Shareddata provider.

See https://angular.io/docs/ts/latest/guide/dependency-injection.html
for more info on providers and Angular 2 DI.
*/
@Injectable()
export class Shareddata {
	public userData: any;
	public loggedIn: boolean = false;
    public is_community_user: any = 'false';
    public is_current_year_mci: any = 'false';
    public selectedSortOptions : any;
    public selectedSortOptionsWithSpace : any;
    public searchText : any;
    public selectedSortOptionsId : number;
    public showVideo: boolean = false;
    public videoUrl: any;
    public scheduleSearchText: any;

	constructor(public http: HttpClient) {
		this.userData = {
			userId: '',
			userName: '',
            fullName: '',
			accessToken: '',
            expiryTime: '',
            loggedTime: ''
		};		
        this.loggedIn = false;
        this.is_community_user = false;
        this.is_current_year_mci = false;
	}

	setUserSession( param ) {
        let currentTime = new Date();
		if ( param != undefined )
		{
			if ( param != undefined ) {
				this.loggedIn = true; //param.loggedIn;
				this.userData = {
					userId: param.userId,
					userName: param.userName,
                    fullName: param.fullname,
					accessToken: param.access_token,
                    expiryTime: param.expires_in,
                    loggedInTime: param.loggedInTime
				};
                this.loggedIn = true; //param.loggedIn;
                this.is_community_user = param.isCommunity;
                this.is_current_year_mci = param.isCurrentYearMCI; 				
			}
		}        
	}

    clearUserSession() {
        this.userData = {
            userId: '',
            userName: '',
            fullName: '',
            accessToken: '',
            expiryTime: '',
            loggedTime: ''
        };
        this.loggedIn = false;
        this.is_community_user = false;
    }

    setSearchOption( param ) {
        if ( undefined != param ) {
            this.selectedSortOptions = param;
            this.selectedSortOptionsWithSpace = param + ' ';
        }
    }

    setSearchOptionId( param ) {
        if ( undefined != param ) {
            this.selectedSortOptionsId = Number( param );
        }
    }

    setSearchText( param ) {
        if ( undefined != param ) {
            this.searchText = param;
        }
    }

    setVideoView( param ) {
        if ( undefined != param ) {
            this.showVideo = param;
        }
    }

    setVideoUrl( param ) {
        if ( undefined != param ) {
            this.videoUrl = param;
        }
    }

    setScheduleSearchText( param ) {
        if ( undefined != param ) {
            this.scheduleSearchText = param;
        }
    }
}